import { EcsType } from '@/pages/flex-group/ecs';
import { GroupsType } from '@/pages/flex-group/group';
import { ProviderType } from '@/pages/flex-group/provider';
import request from '../utils/fetch';

export interface GetGroupParams {
  name: string;
  pageIndex: number;
  pageSize: number;
  provider: string;
  status: string;
}

interface GetGroupResponse {
  pages: number;
  size: number;
  total: number;
  records: GroupsType[];
}

interface ResponseType<T> {
  code: number;
  data: T;
  success: boolean;
}

interface GetProviderResponse {
  pages: number;
  size: number;
  total: number;
  records: ProviderType[];
}

// export interface ProvidersType {
//     accessKey: string;
//     accessSecret: string;
//     id: string;
//     imageId: string;
//     instanceChargeType: string;
//     instanceType: string;
//     name: string;
//     networkChargeType: string;
//     networkType: string;
//     region: string;
//     securityGroupIds: string;
//     tags: string;
//     type: string;
//     userData: string;
//     zoneConfig: string;
// }

interface GetEcsResponse {
  pages: number;
  size: number;
  total: number;
  records: EcsType[];
}

interface GetEcsParams {
  name: string;
  pageIndex: number;
  pageSize: number;
  providerId: string;
  ecsStatusList: string[];
  groupId: string;
}

interface GetProvidersParams {
  name: string;
  pageIndex: number;
  pageSize: number;
}

export const getGroupList = (
  params?: Partial<GetGroupParams>,
): Promise<ResponseType<GetGroupResponse> | undefined> => {
  return request('/scale/v1/scale/group', {
    // tokenFree: true,
    method: 'GET',
    params: {
      ...params,
    },
  }) as any;
};

export const disableGroup = (groupId: string): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/group/${groupId}/disable`, {
    // tokenFree: true,
    method: 'PUT',
  }) as any;
};

export const enableGroup = (groupId: string): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/group/${groupId}/enable`, {
    // tokenFree: true,
    method: 'PUT',
  }) as any;
};

export const addGroup = (data: Partial<GroupsType>): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/group`, {
    // tokenFree: true,
    method: 'POST',
    data,
  }) as any;
};

export const editGroup = (data: Partial<GroupsType>): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/group/update`, {
    // tokenFree: true,
    method: 'PATCH',
    data,
  }) as any;
};

export const getProviderListAll = (): Promise<ResponseType<GetProviderResponse>> => {
  return request('/scale/v1/scale/provider', {
    method: 'GET',
  }) as any;
};

export const getEcsList = (
  params?: Partial<GetEcsParams>,
): Promise<ResponseType<GetEcsResponse>> => {
  return request('/scale/v1/scale/ecs', {
    method: 'GET',
    params,
  }) as any;
};

export const deleteEcs = (ecsIds: string[]): Promise<ResponseType<any>> => {
  return request('/scale/v1/scale/ecs/batchDelete', {
    method: 'PUT',
    data: ecsIds,
  }) as any;
};

export const recycleEcs = (ecsIds: string[]): Promise<ResponseType<any>> => {
  return request('/scale/v1/scale/ecs/forceRecycle', {
    method: 'PUT',
    data: ecsIds,
  }) as any;
};

export const getProviders = (
  params?: Partial<GetProvidersParams>,
): Promise<ResponseType<GetProviderResponse>> => {
  return request('/scale/v1/scale/provider', {
    method: 'GET',
    params,
  }) as any;
};

export const addProvider = (
  data: Partial<ProviderType>,
): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/provider`, {
    // tokenFree: true,
    method: 'POST',
    data,
  }) as any;
};

export const editProvider = (
  data: Partial<ProviderType>,
): Promise<ResponseType<any> | undefined> => {
  return request(`/scale/v1/scale/provider`, {
    // tokenFree: true,
    method: 'PATCH',
    data,
  }) as any;
};

export const deleteProvider = (providerId: string): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/provider`, {
    method: 'DELETE',
    params: { providerId },
  }) as any;
};

export const deleteGroup = (groupId: string): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/group`, {
    method: 'DELETE',
    params: { groupId },
  }) as any;
};

export const updateVersionByNames = (providerNames: string[]): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/provider/version:updateByNames`, {
    method: 'PUT',
    data: providerNames,
  }) as any;
};

export const getUpgradeType = (): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/provider/getUpgradeType`, {
    method: 'GET',
  }) as any;
};

export const getScenario = (): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/group/scenario/ueBizScene/search`, {
    method: 'GET',
  }) as any
}

export const getFlexModelInfo = (params: { modelUrl: string }): Promise<ResponseType<any>> => {
  return request(`/scale/v1/scale/group/model/info`, {
    method: 'GET',
    params
  }) as any
}
